// The @font-face declarations live in a plain stylesheet rather than in the
// styled-components GlobalStyle: styled-components re-injects global styles when it
// remounts during development, and re-injected @font-face rules make the browser
// re-evaluate (and sometimes re-fetch) the font files. A static stylesheet is parsed
// once. Gatsby extracts this import into the build's CSS for both SSR and the client.
require('./src/styles/fonts.css');
